<div class="animated fadeIn">
  <div class="card">
    <div class="card-body">
      <div class="container field-space-btwn">
        <div class="mt-4">
          <form [formGroup]="addContactForm">
            <div class="flex flex-column sm:flex-row gap-4">
              <span class="w-full">
                <label for="contactType"> Contact Type</label>
                <p-dropdown
                  formControlName="contactType"
                  [options]="contactTypes"
                  placeholder="Select Contact Type"
                  optionLabel="label"
                  optionValue="value"
                ></p-dropdown>
              </span>
              <span class="w-full">
                <label for="contactType"> Contact Source</label>
                <p-dropdown
                  formControlName="source"
                  [options]="contactSources"
                  placeholder="Select Contact Source"
                  optionLabel="label"
                  optionValue="value"
                  [editable]="true"
                ></p-dropdown>
              </span>
            </div>

            <formly-form [model]="model" [fields]="fields" [options]="options" [form]="addContactForm"> </formly-form>
          </form>

          <div>
            <p-messages [(value)]="HTTPResponseMessage" [enableService]="false" (click)="createOrUpdateContact()"> </p-messages>
          </div>
          <div class="mt-4 text-right">
            <button
              label="Cancel"
              pButton
              type="button"
              icon="pi pi-times"
              iconPos="left"
              (click)="utilService.goBack(ref)"
              class="p-button-danger mr-2"
            ></button>

            <button
              label="Save"
              pButton
              type="button"
              icon="pi pi-plus"
              iconPos="left"
              (click)="getCustomerNameExistence()"
              [disabled]="!addContactForm.valid"
            ></button>
          </div>
        </div>
        <p-dialog [(visible)]="displayCustomerExistsDialog">
          <ng-template pTemplate="header"> Warning </ng-template>
          A customer with a similar name already exists, do you still wish to proceed?
          <ng-template pTemplate="footer">
            <div class="mt-4 text-right">
              <button
                label="Cancel"
                pButton
                type="button"
                icon="pi pi-times"
                iconPos="left"
                class="p-button-danger mr-2"
                (click)="closeExistingCustomDialog()"
              ></button>

              <button label="Proceed" pButton type="button" icon="pi pi-plus" iconPos="left" (click)="createOrUpdateContact()"></button>
            </div>
          </ng-template>
        </p-dialog>
      </div>
    </div>
  </div>
</div>
